import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import { ILoginState, IMenuState } from '@share/store/slices';
import { RootState, getLocalURI, isExternalUrl, GetDisableNewTabOpen } from '@share/utils';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {
  accountName?: string;
}

function ModernFooterComponent(props: IProps) {
  const { accountName = '', loginStore, menuStore } = props;
  const { account } = loginStore || {};
  const { items } = menuStore || {};

  const footerMenu = items?.footer;
  const disableNewTabOpen = GetDisableNewTabOpen(account, items);

  // Find Privacy Policy item from footer menu
  const privacyPolicyItem = footerMenu?.find(
    (item) =>
      item.title?.toLowerCase().includes('privacy') ||
      item.url?.toLowerCase().includes('privacy-policy') ||
      item.url?.toLowerCase().includes('privacy')
  );

  if (!privacyPolicyItem) {
    return null;
  }

  const forceLocalMenu =
    !privacyPolicyItem?.excludeCheck && import.meta.env.VITE_FORCE_MENU === 'true';
  const isExternal = isExternalUrl(privacyPolicyItem.url as string);
  const localURI = privacyPolicyItem?.url?.replace(/^.*\/\/[^\/]+/, '');
  const isRsi = account?.isRSITemplate && account?.isPrivateTokenAccountType;

  const linkContent = isRsi ? (
    <FormattedMessage id={privacyPolicyItem.title} />
  ) : (
    privacyPolicyItem.title
  );

  return (
    <footer className="modern-footer">
      <div className="modern-footer__container">
        {isEmpty(privacyPolicyItem.url) || privacyPolicyItem?.url === 'disabled' ? (
          <div className="modern-footer__link modern-footer__link--disabled">
            {linkContent}
          </div>
        ) : isExternal && !forceLocalMenu ? (
          <a
            className="modern-footer__link"
            target={disableNewTabOpen ? '_self' : '_blank'}
            rel="noreferrer"
            href={privacyPolicyItem.url}
          >
            {linkContent}
          </a>
        ) : (
          <Link
            className="modern-footer__link"
            to={`/${accountName}${
              isExternal ? localURI : getLocalURI(privacyPolicyItem.url as string)
            }`}
          >
            {linkContent}
          </Link>
        )}
      </div>
    </footer>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    menuStore: state.menuStore,
  };
};

export const ModernFooter = connect(mapStateToProps)(ModernFooterComponent);
